<template>
    <main class="landing-container">
        <section class="slogan">
            <div class="slogan-img" :style="{ backgroundImage: `url(${image})` }"></div>
            <div class="slogan-shadow"></div>
            <div class="main-title-wrapper">
                <div class="main-title">{{ $t('carousel-text5') }}</div>
                <div class="main-subtitle">{{ $t('carousel-text6') }}</div>

                <div class="learn-more-btn" v-on:click="gotoCollections">{{ $t('buy-now') }}</div>
            </div>
        </section>

        <section class="section-top-collections" ref="collections">
            <HomeTopCollections class="home-collections-container" :collections-list="topCollectionItems" :additional-data="true"></HomeTopCollections>
        </section>

        <section class="why-invest-wrapper">
            <div class="container">
                <div class="collections-h1">{{ $t('home1') }}</div>
                <v-row>
                    <v-col class="col-xs-12 col-md-4 right-half-padding">
                        <div class="how-icon sold">
                            <div class="card-icon"></div>
                            <div class="card-title">{{ $t('home2') }}</div>
                            <div class="card-text">{{ $t('home3') }}</div>
                        </div>
                    </v-col>
                    <v-col class="col-xs-12 col-md-4 right-half-padding left-half-padding">
                        <div class="how-icon secure">
                            <div class="card-icon"></div>
                            <div class="card-title">{{ $t('home4') }}</div>
                            <div class="card-text">{{ $t('home5') }}</div>
                        </div>
                    </v-col>
                    <v-col class="col-xs-12 col-md-4 left-half-padding">
                        <div class="how-icon transparency">
                            <div class="card-icon"></div>
                            <div class="card-title">{{ $t('home6') }}</div>
                            <div class="card-text">{{ $t('home7') }}</div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapGetters} from "vuex";
    import {GOrders} from "../store/getters";
    import {AOrders} from "../store/actions";
    import HomeTopCollections from "../components/home/HomeTopCollections2";

    export default {
        name: "LpInvestor",
        head: {
            title: 'Christmas campaign for investors | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-landing-investor'
            }
        },
        components: {
            HomeTopCollections
        },
        data () {
            return {
                topCollectionItems: [],
                image: null
            }
        },
        computed: {
            ...mapGetters({
                topCollectionsList: GOrders.GET_TOP_COLLECTIONS,
                collectionsList: GOrders.GET_COLLECTIONS
            }),
            topCollectionIds() {
                let _list = [];
                this.topCollectionsList.forEach(el => {
                    _list.push(el.collectionId)
                });
                return _list
            }
        },
        methods: {
            gotoCollections() {
                // this.$router.push('/home/collections');
                let element = this.$refs['collections'];
                let top = element.offsetTop - 100;

                window.scrollTo({
                    top: top,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        },
        mounted() {
            this.image = window.innerWidth > 1279 ? require('@/assets/home/carousel/hero-3.jpg') : ( window.innerWidth > 767 ? require('@/assets/home/carousel/hero-3m.jpg') : require('@/assets/home/carousel/hero-3s.jpg'))

            this.$store.dispatch(AOrders.GET_TOP_COLLECTIONS, this.$i18n.locale);

            this.collectionItems = [];
            this.$store.dispatch(AOrders.GET_COLLECTIONS, this.$i18n.locale).then(() => {
                this.collectionItems = this.collectionsList;

                let homeCtrl = this;
                this.collectionItems.forEach(item => {
                    if (homeCtrl.topCollectionIds.indexOf(item.id) > -1) {
                        homeCtrl.topCollectionItems.push(item)
                    }
                })
            });
        }
    }
</script>

<style scoped>
    .slogan {
        height: 400px;
        position: relative;
    }
    .slogan-shadow {
        background: rgba(0,0,0,0.44);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .slogan-img {
        background-size: cover;
        background-position: center bottom;
        width: 100%;
        height: 100%;
    }
    .main-title-wrapper {
        position: absolute;
        left: calc((100% - 1366px)/2);
        top: 100px;
    }
    .main-title {
        width: 1366px;
        font-family: Montserrat, sans-serif;
        text-transform: uppercase;
        font-style: normal;
        font-weight: bold;
        font-size: 34px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    .main-subtitle {
        max-width: 685px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 29px;
        color: #FFFFFF;
        text-align: center;
        margin: 8px auto;
    }
    .learn-more-btn {
        display: block;
        padding: 8px 16px;
        width: 150px;
        height: 40px;
        background: #CEA94B;
        border-radius: 4px;
        margin: 45px auto 0;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        text-transform: uppercase;
        color: #FFFFFF;
    }
    .learn-more-btn:hover {
        cursor: pointer;
    }
    .section-top-collections {
        max-width: 1184px;
        margin: 40px auto;
    }
    .why-invest-wrapper {
        background: #F6F6F6;
        padding: 30px 0;
        margin-bottom: 35px;
    }
    .collections-h1 {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 40px;
        line-height: 120%;
        text-align: center;
        color: #303030;
        margin-bottom: 35px;
    }
    .card-icon {
        height: 80px;
        width: 100%;
        margin-bottom: 20px;
    }
    .card-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-size: 25px;
        line-height: 30px;
        margin-bottom: 16px;
        font-weight: 700;
        color: #303030;
        text-align: center;
        text-transform: uppercase;
    }
    .card-text {
        margin-bottom: 11px;
        text-align: center;
        font-size: 16px;
        line-height: 26px;
        font-weight: 300;
    }
    .secure .card-icon {
        background: url('../assets/home/secure.png') no-repeat center center;
        background-size: contain;
    }
    .sold .card-icon {
        background: url('../assets/home/easy.png') no-repeat center center;
        background-size: contain;
    }
    .transparency .card-icon {
        background: url('../assets/home/dynamic.png') no-repeat center center;
        background-size: contain;
    }
    .right-half-padding {
        padding-right: 25px;
    }
    .left-half-padding {
        padding-left: 25px;
    }
    .container {
        position: relative;
        max-width: 1170px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }

    @media (max-width: 1366px) {
        .main-title,
        .main-subtitle {
            width: 100%;
        }
        .main-title-wrapper {
            width: 100%;
            left: 0;
            padding: 0 15px;
            top: 140px;
        }
    }

    @media(max-width: 767px) {
        .collections-h1 {
            font-size: 24px;
            line-height: 30px;
        }
        .main-title {
            font-size: 24px;
            line-height: 29px;
        }
        .main-subtitle {
            font-size: 18px;
            line-height: 22px;
            font-weight: normal;
        }
        .why-invest-wrapper .row {
            display: block;
        }
        .col-xs-12 {
            padding-left: 25px;
            padding-right: 25px;
        }
    }
</style>
<style>
    .page-landing-investor .nav-second-row {
        display: none;
    }
</style>
